import { useAppDispatch } from "../store/hooks"
import { applyCoupon, updateCartItem } from "../store/slices/cartSlice"
import { addToWishlist, removeFromWishlist } from "../store/slices/wishlistSlice"
import { useCartOperations } from "./useCartOperations"

export const useProductActions = () => {
  const dispatch = useAppDispatch()
  const { updateQuantity, removeItem, addItem } = useCartOperations()

  const addToCart = (productId, quantity = 1, redirectToCart = false) => {
    return addItem(productId, quantity, redirectToCart)
  }

  const updateCartQuantity = (productId, quantity) => {
    return updateQuantity(productId, quantity, "update")
  }

  const removeFromCart = (productId) => {
    return removeItem(productId)
  }

  const applyRemoveCoupon = (couponCode) => {
    return dispatch(
      applyCoupon(
        couponCode,
      ),
    )
  }

  const toggleWishlist = (productId, isInWishlist) => {
    if (isInWishlist) {
      return dispatch(removeFromWishlist(productId))
    } else {
      return dispatch(addToWishlist(productId))
    }
  }

  const moveToWishlist = (productId) => {
    dispatch(addToWishlist(productId))
    return removeItem(productId)
  }

  const moveToCart = (productId, quantity = 1) => {
    dispatch(removeFromWishlist(productId))
    return addItem(productId, quantity)
  }

  return {
    addToCart,
    updateCartQuantity,
    removeFromCart,
    applyRemoveCoupon,
    toggleWishlist,
    moveToWishlist,
    moveToCart,
  }
}
